import { useCallback, useContext } from "react";
import { StateContext, DispatchContext } from "bodycodi/cmap/app/components/common/context";
import CustomDialog from "bodycodi/cmap/app/components/common/customDialog";
import icon_back from "bodycodi/cmap/app/svg/icon_back.svg";
import icon_sub from "bodycodi/cmap/app/svg/icon_sub.svg";

const NUTRITION_ARR = [
  {
    name: "총지방",
    mainYn: "Y",
    eName: "fat",
    unit: "g",
    oneDayStandard: 54,
  },
  {
    name: "포화지방",
    mainYn: "N",
    eName: "saturatedfat",
    unit: "g",
    oneDayStandard: 15,
  },
  {
    name: "트랜스지방",
    mainYn: "N",
    eName: "transfat",
    unit: "g",
    oneDayStandard: 2,
  },
  {
    name: "콜레스테롤",
    mainYn: "Y",
    eName: "cholesterol",
    unit: "mg",
    oneDayStandard: 300,
  },
  {
    name: "나트륨",
    mainYn: "Y",
    eName: "sodium",
    unit: "mg",
    oneDayStandard: 2000,
  },
  {
    name: "탄수화물",
    mainYn: "Y",
    eName: "carbonhydrate",
    unit: "g",
    oneDayStandard: 324,
  },
  {
    name: "설탕",
    mainYn: "N",
    eName: "sugar",
    unit: "g",
    oneDayStandard: 50,
  },
  {
    name: "단백질",
    mainYn: "Y",
    eName: "protein",
    unit: "g",
    oneDayStandard: 55,
  },
];

const FoodDetailPop = () => {
  const { dispatch } = useContext(DispatchContext);
  const { state } = useContext(StateContext);
  const { eatAmount, foodName, nutrition, unit } = state.comunityFoodDetail;

  const handleClose = useCallback(() => {
    dispatch({
      type: "POP_UP_OPEN",
      id: "COMUNITY_FOOD_DTL_POP",
      open: { comunityFoodDtlPop: false },
    });
  }, []);

  if (!eatAmount) {
    return <></>;
  }

  return (
    <CustomDialog open={state.comunityFoodDtlPop} onClose={handleClose}>
      <header className="popup-header">
        <div
          style={{
            width: "100%",
            justifyContent: "space-between",
          }}
          className="community-detail"
        >
          <div onClick={handleClose} className="left-icon">
            <img src={icon_back} />
          </div>
          <div className="comunity-content-header no-margin">영양 정보 전체</div>
          <div
            style={{
              visibility: "hidden",
            }}
          >
            <img src={icon_back} />
          </div>
        </div>
      </header>
      <div className="food-dtl-pop">
        <div className="food-dtl-header">
          <div>
            <div className="name">{foodName}</div>
            <div className="unit">
              {unit}
              {eatAmount > 1 && ` x${eatAmount % 1 === 0 ? eatAmount : eatAmount.toFixed(1)}`}
            </div>
          </div>
          <div className="info">
            <span className="kcal">
              {nutrition.calories}
              <span> kcal</span>
            </span>
            <span className="totalgram">제공량 {nutrition.totalgram}g</span>
          </div>
        </div>
        <div className="food-dtl-contents">
          {NUTRITION_ARR.map((v) => (
            <div key={v.eName} className="food-dtl-contents-box">
              <div className="name">
                {v.mainYn === "Y" ? (
                  <span className="name-main">{v.name} </span>
                ) : (
                  <>
                    <img src={icon_sub} alt="ㄴ" />
                    <span className="name-sub">{v.name} </span>
                  </>
                )}
                <span className="nutrition">
                  ({nutrition[v.eName]}
                  {v.unit})
                </span>
              </div>
              <div>
                <span className="standard">
                  {Math.round((nutrition[v.eName] / v.oneDayStandard) * 100)}
                </span>
                <span className="per">%</span>
              </div>
            </div>
          ))}
        </div>
        <div className="food-dtl-desc">
          <p>% 일 섭취량</p>
          <p>
            % 정보는 2000kcal 기준 정보입니다. 칼로리 소비량에 따라 실제값은 높거나 낮을 수
            있습니다.
          </p>
        </div>
      </div>
    </CustomDialog>
  );
};

export default FoodDetailPop;
